/**
 * Novelarc 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const novelarcPaymentConfig: BrandPaymentConfig = {
  brand: 'novelarc',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/novelarc/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/novelarc/vip_bg.webp',
      memberSubscribeBg: '/images/novelarc/member_subscribe_bg.webp',
      vipIcon: '/images/novelarc/vip_icon2.png',
      vipDiscountIcon: '/images/novelarc/vip_discount.png',
      discountBg: '/images/novelarc/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #FFCAA8 0%, #FFE0CC 70%, #FFF8F5 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置（沿用 rocnovel 的配置风格）
  chapter: {
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #FFA81E, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#FF873F',
      coinsPopupText3: '#65686F',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#FFF8F5',
      subscribeActiveBg: '#F3F5FA',
      purpleTextGradient: 'linear-gradient(180deg, #FFCAA8 0%, #FFE0CC 70%, #FFF8F5 100%)',
      pinkGradient: 'linear-gradient(90deg, #FFA81E 0%, #FF771C 100%)',
      memberSubscribeBg: '/images/novelarc/chapter/member_subscribe_bg.webp',
      showVipIcon: true,
    },
  },
}
